export const APP_BANNER_MOBILE_APP_APPLE_STORE =
  'https://app.adjust.com/k2bysd';
export const MOBILE_APP_APPLE_STORE =
  'https://apps.apple.com/ru/app/locals-%D1%81%D0%BD%D1%8F%D1%82%D1%8C-%D0%B1%D0%B5%D0%B7-%D0%BF%D0%BE%D1%81%D1%80%D0%B5%D0%B4%D0%BD%D0%B8%D0%BA%D0%BE%D0%B2/id1003769301';
export const MOBILE_APP_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.locals';
